import { createStore, applyMiddleware } from "redux";
import reducer from "./ducks";

const middlewares = [];

if (process.env.NODE_ENV !== "production") {
  const { logger } = require("redux-logger");
  middlewares.push(logger);
}

const store = createStore(reducer, applyMiddleware(...middlewares));

export default store;
